module.exports = __webpack_public_path__ + "static/media/stomach.5145ea95.svg";